import axios from "axios";
import {
  createMetaEventId,
  getMetaBrowserIdentifiers,
  trackMetaAction,
} from "../utils/metaPixel";
import {
  isAnalyticsConsentEnabled,
  isMarketingConsentEnabled,
} from "../utils/privacyConsent";
const API_URL = process.env.REACT_APP_API_URL;

export function getLojaPorUsername(username) {
  return axios
    .get(`${API_URL}/public/loja/${username}`)
    .then((response) => response.data)
    .catch((error) => {
      const errorMessage =
        error.response?.data?.error || "Erro ao obter informações da loja.";
      throw new Error(errorMessage);
    });
}

export function getProdutosPorUsername(username) {
  return axios
    .get(`${API_URL}/public/produtos/${username}`)
    .then((response) => response.data)
    .catch((error) => {
      const errorMessage =
        error.response?.data?.error || "Erro ao obter produtos da loja.";
      throw new Error(errorMessage);
    });
}

export function registrarAcao(dto) {
  const analyticsEnabled = isAnalyticsConsentEnabled();
  const marketingEnabled = isMarketingConsentEnabled();
  const metaEventId = dto?.meta_event_id || createMetaEventId(dto?.tipo_acao || "acao");

  if (marketingEnabled) {
    trackMetaAction({
      tipo_acao: dto?.tipo_acao,
      produto_id: dto?.produto_id,
      termo_busca: dto?.termo_busca,
      eventId: metaEventId,
    });
  }

  if (!analyticsEnabled) {
    return Promise.resolve({ skipped: true });
  }

  const ids = marketingEnabled
    ? getMetaBrowserIdentifiers()
    : { fbp: null, fbc: null };
  const payload = {
    ...dto,
    meta_event_id: metaEventId,
    fbp: dto?.fbp || ids.fbp || null,
    fbc: dto?.fbc || ids.fbc || null,
    event_source_url: dto?.event_source_url || (typeof window !== "undefined" ? window.location.href : null),
  };

  return axios.post(`${API_URL}/public/analise/acao`, payload);
}

export function getProdutosFiltradosPaginado(
  username,
  { page, limit = 8, tag, busca }
) {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (tag && tag !== "todas") params.append("tag", tag);
  if (busca?.trim()) params.append("busca", busca.trim());

  return axios
    .get(`${API_URL}/public/produtos/${username}?${params.toString()}`)
    .then((res) => res.data);
}

export function getProdutoPublicoById(produtoId, lojaId) {
  return axios
    .get(`${API_URL}/public/produto/${produtoId}`, {
      params: { lojaId },
    })
    .then((res) => res.data)
    .catch((error) => {
      const errorMessage =
        error.response?.data?.error || "Erro ao buscar produto.";
      throw new Error(errorMessage);
    });
}

export function getNudgesCatalogo(username, { tag } = {}) {
  const params = new URLSearchParams();
  if (tag) params.append("tag", tag);
  const query = params.toString();

  return axios
    .get(`${API_URL}/public/nudges/${username}${query ? `?${query}` : ""}`)
    .then((res) => res.data);
}

export function registrarPushSubscription(username, payload) {
  return axios
    .post(`${API_URL}/public/push/${username}/subscribe`, payload)
    .then((res) => res.data);
}

export function cancelarPushSubscription(username, payload) {
  return axios
    .post(`${API_URL}/public/push/${username}/unsubscribe`, payload)
    .then((res) => res.data);
}

export function registrarVisitaLanding(payload) {
  if (!isAnalyticsConsentEnabled()) {
    return Promise.resolve({ skipped: true });
  }

  return axios.post(`${API_URL}/public/landing/visit`, payload);
}
